import type { CustomerCreditsStore } from './interfaces'

export const getters = {
  getProgram: (state: CustomerCreditsStore): CustomerCreditsStore['program'] => state.program,
  getReferrals: (state: CustomerCreditsStore): CustomerCreditsStore['referrals'] => state.referrals,
  getReferralsMeta: (state: CustomerCreditsStore): CustomerCreditsStore['referralsMeta'] => state.referralsMeta,
  isReferralsLoading: (state: CustomerCreditsStore): CustomerCreditsStore['referralsLoading'] => state.referralsLoading,
  getTransactions: (state: CustomerCreditsStore): CustomerCreditsStore['transactions'] => state.transactions,
  getTransactionsMeta: (state: CustomerCreditsStore): CustomerCreditsStore['transactionsMeta'] => state.transactionsMeta,
  isTransactionsLoading: (state: CustomerCreditsStore): CustomerCreditsStore['transactionsLoading'] => state.transactionsLoading,
  isProcessing: (state: CustomerCreditsStore): CustomerCreditsStore['processing'] => state.processing,
  isModalEdit: (state: CustomerCreditsStore): CustomerCreditsStore['modalEdit'] => state.modalEdit,
}
